// 스마트스토어 배송사 코드표(delivery-companies xls) 기반 — 코드가 저장값, 이름이 표시값이다.
export interface PathPickDeliveryCompany {
  code: string;
  name: string;
}

export const PATH_PICK_DELIVERY_COMPANIES: PathPickDeliveryCompany[] = [
  { code: "CJGLS", name: "CJ대한통운" },
  { code: "HYUNDAI", name: "롯데택배" },
  { code: "HANJIN", name: "한진택배" },
  { code: "KGB", name: "로젠택배" },
  { code: "EPOST", name: "우체국택배" },
  { code: "1004HOME", name: "1004HOME" },
  { code: "TWOFASTEXPRESS", name: "2FAST익스프레스" },
  { code: "ACE", name: "ACEexpress" },
  { code: "ACIEXPRESS", name: "ACI" },
  { code: "ADCAIR", name: "ADC항운택배" },
  { code: "AIRWAY", name: "AIRWAY익스프레스" },
  { code: "ARAMEX", name: "ARAMEX" },
  { code: "ARGO", name: "ARGO" },
  { code: "AIRBOY", name: "AirboyExpress" },
  { code: "KOREXG", name: "CJ대한통운(국제택배)" },
  { code: "CJGLSDAWN", name: "CJ대한통운(새벽배송)" },
  { code: "CU", name: "CU편의점(퀵배달용)" },
  { code: "CUPARCEL", name: "CU편의점택배" },
  { code: "CWAYEXPRESS", name: "CwayExpress" },
  { code: "DHL", name: "DHL" },
  { code: "DHLDE", name: "DHL(독일)" },
  { code: "DHLGLOBALMAIL", name: "DHLGlobalMail" },
  { code: "DPD", name: "DPD" },
  { code: "ECMSEXPRESS", name: "ECMSExpress" },
  { code: "EFS", name: "EFS" },
  { code: "EMS", name: "EMS" },
  { code: "EZUSA", name: "EZUSA" },
  { code: "EUROPARCEL", name: "EuroParcel" },
  { code: "FEDEX", name: "FEDEX" },
  { code: "GOP", name: "GOP당일택배" },
  { code: "GOS", name: "GOS당일택배" },
  { code: "GPSLOGIX", name: "GPSLOGIX" },
  { code: "GSFRESH", name: "GSFresh" },
  { code: "GSIEXPRESS", name: "GSI익스프레스" },
  { code: "GSMNTON", name: "GSMNTON" },
  { code: "GSPOSTBOX", name: "GSPostbox퀵" },
  { code: "CVSNET", name: "GSPostbox택배" },
  { code: "GS25", name: "GS편의점(퀵배달용)" },
  { code: "GTSLOGIS", name: "GTS로지스" },
  { code: "HYBRID", name: "HI택배" },
  { code: "HY", name: "HY" },
  { code: "IK", name: "IK물류" },
  { code: "JCLS", name: "JCLS" },
  { code: "JWTNL", name: "JWTNL" },
  { code: "KGLNET", name: "KGL네트웍스" },
  { code: "KT", name: "KT EXPRESS" },
  { code: "AMZL", name: "L" },
  { code: "AMZDHL", name: "L1" },
  { code: "LGE", name: "LG전자배송센터" },
  { code: "LTL", name: "LTL" },
  { code: "PANTOS", name: "LX판토스" },
  { code: "NDEXKOREA", name: "NDEX KOREA" },
  { code: "SBGLS", name: "SBGLS" },
  { code: "SFEX", name: "SFexpress" },
  { code: "SLX", name: "SLX택배" },
  { code: "SSG", name: "SSG" },
  { code: "TNT", name: "TNT" },
  { code: "LOGISPARTNER", name: "UFO로지스" },
  { code: "UPS", name: "UPS" },
  { code: "USPS", name: "USPS" },
  { code: "W7", name: "W7" },
  { code: "WIZWA", name: "WIZWA" },
  { code: "YJSWORLD", name: "YJS글로벌" },
  { code: "YJS", name: "YJS글로벌(영국)" },
  { code: "YUNDA", name: "YUNDAEXPRESS" },
  { code: "IPARCEL", name: "i-parcel" },
  { code: "KY", name: "건영복합물류" },
  { code: "KUNYOUNG", name: "건영택배" },
  { code: "KDEXP", name: "경동택배" },
  { code: "KIN", name: "경인택배" },
  { code: "GONELO", name: "고넬로" },
  { code: "KORYO", name: "고려택배" },
  { code: "GDSP", name: "골드스넵스" },
  { code: "KOKUSAI", name: "국제익스프레스" },
  { code: "GOODTOLUCK", name: "굿투럭" },
  { code: "NAEUN", name: "나은물류" },
  { code: "NOGOK", name: "노곡물류" },
  { code: "NONGHYUP", name: "농협택배" },
  { code: "HANAROMART", name: "농협하나로마트" },
  { code: "DAELIM", name: "대림통운" },
  { code: "DAESIN", name: "대신택배" },
  { code: "DAEWOON", name: "대운글로벌" },
  { code: "THEBAO", name: "더함전자물류" },
  { code: "DODOFLEX", name: "도도플렉스" },
  { code: "DONGGANG", name: "동강물류" },
  { code: "DONGJIN", name: "동진특송" },
  { code: "CHAINLOGIS", name: "두발히어로당일택배" },
  { code: "DNDN", name: "든든택배" },
  { code: "DRABBIT", name: "딜리래빗" },
  { code: "JMNP", name: "딜리박스" },
  { code: "ONEDAYLOGIS", name: "라스트마일" },
  { code: "LINEEXP", name: "라인익스프레스" },
  { code: "LETUS3PL", name: "레터스" },
  { code: "ROADSUNEXPRESS", name: "로드썬익스프레스" },
  { code: "LOGISVALLEY", name: "로지스밸리" },
  { code: "POOLATHOME", name: "로지스올홈케어(풀앳홈)" },
  { code: "LOTOS", name: "로토스" },
  { code: "HLCGLOBAL", name: "롯데글로벌로지스(국제택배)" },
  { code: "LOTTECHILSUNG", name: "롯데칠성" },
  { code: "RETURNALL", name: "리터놀" },
  { code: "MYALLTV", name: "마이로지스" },
  { code: "MORNINGGLOBAL", name: "모닝글로벌" },
  { code: "MDLOGIS", name: "모든로지스(SLO)" },
  { code: "FTF", name: "물류대장(설치)" },
  { code: "DASONG", name: "물류대장(택배)" },
  { code: "LETUS", name: "바로스" },
  { code: "BABABA", name: "바바바로지스" },
  { code: "HWATONG", name: "박스앤" },
  { code: "BANPOOM", name: "반품구조대" },
  { code: "VALEX", name: "발렉스" },
  { code: "SHIPNERGY", name: "배송하기좋은날" },
  { code: "VENDORPIA", name: "벤더피아" },
  { code: "VROONG", name: "부릉" },
  { code: "BRIDGE", name: "브릿지로지스" },
  { code: "BRCH", name: "비알씨에이치" },
  { code: "EKDP", name: "삼다수가정배송" },
  { code: "SEAC", name: "삼성전자 시스템에어컨 물류" },
  { code: "SELC", name: "삼성전자물류" },
  { code: "SEORIM", name: "서림물류" },
  { code: "SWGEXP", name: "성원글로벌" },
  { code: "SUNGHUN", name: "성훈물류" },
  { code: "SEBANG", name: "세방택배" },
  { code: "SEVENELEVEN", name: "세븐일레븐" },
  { code: "SUPERKITCHEN", name: "슈퍼키친" },
  { code: "SNOWFOXFLOWER", name: "스노우폭스플라워" },
  { code: "SMARTLOGIS", name: "스마트로지스" },
  { code: "SPARKLE", name: "스파클직배송" },
  { code: "SPASYS1", name: "스페이시스원" },
  { code: "CRLX", name: "시알로지텍" },
  { code: "CASA", name: "신세계까사" },
  { code: "ANYTRACK", name: "애니트랙" },
  { code: "ABOUTPET", name: "어바웃펫" },
  { code: "ESTHER", name: "에스더쉬핑" },
  { code: "ACTCORE", name: "에이씨티앤코아" },
  { code: "HKHOLDINGS", name: "에이치케이홀딩스" },
  { code: "NTLPS", name: "엔티엘피스" },
  { code: "MTINTER", name: "엠티인터내셔널" },
  { code: "RUSH", name: "오늘회러쉬" },
  { code: "ONDAY", name: "온데이 당일택배" },
  { code: "ALLIN", name: "올인닷컴" },
  { code: "ALLTAKOREA", name: "올타코리아" },
  { code: "WIDETECH", name: "와이드테크" },
  { code: "YONGMA", name: "용마로지스" },
  { code: "DCOMMERCE", name: "우리동네커머스" },
  { code: "WEVILL", name: "우리동네택배" },
  { code: "HONAM", name: "우리택배" },
  { code: "WOOJIN", name: "우진인터로지스" },
  { code: "REGISTPOST", name: "우편등기" },
  { code: "WOONGJI", name: "웅지익스프레스" },
  { code: "WARPEX", name: "워펙스" },
  { code: "WINION", name: "위니온로지스" },
  { code: "WINIONAC", name: "위니온에어컨" },
  { code: "WIHTYOU", name: "위드유당일택배" },
  { code: "WITHCOMPANY", name: "위드컴퍼니" },
  { code: "WEMOVE", name: "위무브" },
  { code: "UFREIGHT", name: "유프레이트코리아" },
  { code: "EUNHA", name: "은하쉬핑" },
  { code: "INNOS", name: "이노스(올인닷컴)" },
  { code: "EMART24", name: "이마트24" },
  { code: "EMARTEVERYDAY", name: "이마트에브리데이" },
  { code: "ESTLA", name: "이스트라" },
  { code: "ETOMARS", name: "이투마스" },
  { code: "GENERALPOST", name: "일반우편" },
  { code: "ILSHIN", name: "일신모닝택배" },
  { code: "ILYANG", name: "일양로지스" },
  { code: "GNETWORK", name: "자이언트" },
  { code: "JANGBOGOMART", name: "장보고식자재마트" },
  { code: "ZENIEL", name: "제니엘시스템" },
  { code: "JLOGIST", name: "제이로지스트" },
  { code: "GENIEGO", name: "지니고당일특급" },
  { code: "GDAKOREA", name: "지디에이코리아" },
  { code: "GCS", name: "지씨에스" },
  { code: "GHSPEED", name: "지에이치스피드" },
  { code: "GKGLOBAL", name: "지케이글로벌" },
  { code: "JIKGUMOON", name: "직구문" },
  { code: "CHUNIL", name: "천일택배" },
  { code: "CHOROCMAEUL", name: "초록마을(네이버직연동)" },
  { code: "CHOROC", name: "초록마을(외부연동)" },
  { code: "TODAYPICKUP", name: "카카오T당일배송" },
  { code: "COSHIP", name: "캐나다쉬핑" },
  { code: "CONTROLLOGIS", name: "컨트롤로지스" },
  { code: "KURLY", name: "컬리넥스트마일" },
  { code: "KJT", name: "케이제이티" },
  { code: "QRUN", name: "큐런" },
  { code: "CUBEFLOW", name: "큐브플로우" },
  { code: "HEREWEGO", name: "탱고앤고" },
  { code: "TOMATO", name: "토마토앱" },
  { code: "TODAY", name: "투데이" },
  { code: "QXPRESS", name: "트랙스로지스" },
  { code: "TSG", name: "티에스지로지스" },
  { code: "TEAMFRESH", name: "팀프레시" },
  { code: "PATEK", name: "파테크해운상공" },
  { code: "XINPATEK", name: "파테크해운항공" },
  { code: "PANASIA", name: "판월드로지스틱" },
  { code: "PANSTAR", name: "팬스타국제특송(PIEX)" },
  { code: "FOREVER", name: "퍼레버택배" },
  { code: "POLYPARK", name: "폴리파크" },
  { code: "FOODTECH", name: "푸드테크" },
  { code: "PULMUONE", name: "풀무원(로지스밸리)" },
  { code: "FREDIT", name: "프레딧" },
  { code: "FRESHMATES", name: "프레시메이트" },
  { code: "PINGPONG", name: "핑퐁" },
  { code: "HOWSER", name: "하우저" },
  { code: "HIVECITY", name: "하이브시티" },
  { code: "HANDALUM", name: "한달음택배" },
  { code: "HANDEX", name: "한덱스" },
  { code: "HANMI", name: "한미포스트" },
  { code: "HANSSEM", name: "한샘" },
  { code: "HANSSEMSOFA", name: "한샘소파" },
  { code: "HANWOORI", name: "한우리물류" },
  { code: "HPL", name: "한의사랑택배" },
  { code: "HDEXP", name: "합동택배" },
  { code: "HERWUZUG", name: "허우적" },
  { code: "GLOVIS", name: "현대글로비스" },
  { code: "HOMEINNO", name: "홈이노베이션로지스" },
  { code: "HOMEPLUSDELIVERY", name: "홈플러스" },
  { code: "HOMEPLUSEXPRESS", name: "홈플러스익스프레스" },
  { code: "HOMEPICKTODAY", name: "홈픽오늘도착" },
  { code: "HOMEPICK", name: "홈픽택배" },
  { code: "CARGOPLEASE", name: "화물을부탁해" },
  { code: "GSTHEFRESH", name: "GS더프레시" },
  { code: "CH1", name: "기타택배" },
];

// 배송방법 — 선택 UI는 없어졌고(택배사를 고르는 화면이라 택배로 고정) 요청/응답 타입에만 남는다.
export type PathPickDeliveryType = "DELIVERY" | "DIRECT";
